import TableActions from './TableActions'

export default TableActions



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/components/TableActions/index.js